import {OperationTypes} from '@jimmyn/apollo-client';
import {Button, Modal} from 'antd';
import {
  ResumeSubscriptionInput,
  SubscriptionFieldsFragment,
  useResumeSubscriptionMutation
} from 'api/generated';
import {subscriptionQuery} from 'api/queries';
import {Formik} from 'formik';
import {Form} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import {formatUnixDate} from 'lib/formaters';
import React, {useState} from 'react';

type Props = {subscription: SubscriptionFieldsFragment};

export const ResumeSubscription: React.FC<Props> = ({subscription}) => {
  const [isOpen, setOpen] = useState(false);

  const [resumeSubscription] = useResumeSubscriptionMutation({
    updateQuery: {query: subscriptionQuery, variables: {subscriptionId: subscription?.id}},
    operationType: OperationTypes.UPDATE
  });

  const initialValues: ResumeSubscriptionInput = {
    id: subscription.id,
    accountId: subscription.accountId
  };
  const handleResume = async (
    input: ResumeSubscriptionInput,
    {setSubmitting, resetForm}: FormikHelpers<typeof initialValues>
  ) => {
    await resumeSubscription({variables: {input}});
    setSubmitting(false);
    setOpen(false);
    setTimeout(resetForm, 100);
  };

  return (
    <>
      <Button onClick={() => setOpen(true)}>Resume</Button>
      <Formik<ResumeSubscriptionInput> initialValues={initialValues} onSubmit={handleResume}>
        {({submitForm, isSubmitting, resetForm}) => (
          <Modal
            title="Resume subscription"
            okText="Resume subscription"
            cancelText="Never mind"
            open={isOpen}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            afterClose={resetForm}
            onCancel={() => setOpen(false)}>
            <Form layout="vertical">
              Subscription will be resumed immediately. Next payment will be on{' '}
              <b>{formatUnixDate(subscription.currentPeriodEnd)}</b>
              <input type="submit" value="submit" hidden />
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
